import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import { Paper, Divider } from '@material-ui/core';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import IconMenu from 'material-ui/IconMenu';
import { grey400 } from 'material-ui/styles/colors';
import { PRODUCT_LIST_URL } from '../../../../../route-names';
import { Link } from 'react-router-dom';
import { RENEWALS_PORTAL_URL } from '../../../../../route-names';
import { injectIntl } from 'react-intl';

const RenewalsActionPanel = (props) => {
  const iconButtonElement = (
    <IconButton touch tooltipPosition="bottom-left">
      <FontIcon color={grey400} className="material-icons">
        keyboard_arrow_right
      </FontIcon>
    </IconButton>
  );

  const rightIconMenu = (
    <IconMenu iconButtonElement={iconButtonElement}></IconMenu>
  );

  return (
    <Paper>
      <List style={{ padding: '0px 0px 0px 0px' }}>
        <Subheader className="subheader">
          {props.intl.formatMessage({
            id: 'renewals_action_panel.title'
          })}
        </Subheader>
        {props.customers.map((customer, index) => (
          <Link
            key={index}
            to={PRODUCT_LIST_URL.replace(
              ':branchRouteCustomerId',
              `${customer.branchId}:${customer.routeNumber}:${customer.customerId}`
            )}
          >
            <ListItem
              leftAvatar={
                <Avatar
                  icon={
                    <FontIcon className="material-icons">
                      priority_high
                    </FontIcon>
                  }
                />
              }
              primaryText={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span> {customer.deliverToCustomerName} </span>
                  <span> Current Approval Tier: {customer?.workflowTicket?.currentApprovalTier} </span>
                </div>
              }
              secondaryText={`Customer #: ${customer.deliverToCustomerNumber}`}
              rightIconButton={rightIconMenu}
            />
            <Divider variant="inset" />
          </Link>
        ))}
        <Link to={RENEWALS_PORTAL_URL}>
          <Subheader className="subfooter">
            {props.intl.formatMessage({
              id: 'see_all'
            })}
          </Subheader>
        </Link>
      </List>
    </Paper>
  );
};

RenewalsActionPanel.propTypes = {
  customers: PropTypes.array
};

export default injectIntl(RenewalsActionPanel);
